import "sanity/bundle.css";
import { a as EDIT_INTENT_MODE, n as DEFAULT_TOOL_ICON } from "./constants-CW-F48Fx.js";
import { a as presentationUsEnglishLocaleBundle, i as presentationLocaleNamespace, n as usePresentationTool, r as usePresentationVariant, t as usePresentationNavigate } from "./usePresentationNavigate-DhoGmkX9.js";
import { t as usePresentationParams } from "./usePresentationParams-B_1iItpx.js";
import { c } from "react/compiler-runtime";
import { Suspense, lazy, useContext, useEffect, useLayoutEffect, useState } from "react";
import { useObservable } from "react-rx";
import { defer, isObservable, map, of, tap } from "rxjs";
import { PresentationContext, PresentationDocumentContext, PresentationSharedStateContext } from "sanity/_singletons";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { startWith as startWith$1 } from "rxjs/operators";
import { WarningOutlineIcon } from "@sanity/icons/WarningOutline";
import { Box, Flex, Icon, Text } from "ui5";
import { Card, Spinner, rem } from "@sanity/ui";
import { useEffectEvent as useEffectEvent$1 } from "use-effect-event";
import { css, styled } from "styled-components";
import { getTheme_v2 } from "@sanity/ui/theme";
import { InfoOutlineIcon } from "@sanity/icons/InfoOutline";
import { encodeJsonParams, route, useIntentLink, useRouter } from "sanity/router";
import { uuid } from "@sanity/uuid";
import { DesktopIcon } from "@sanity/icons/Desktop";
import { ErrorOutlineIcon } from "@sanity/icons/ErrorOutline";
import { ChevronRightIcon } from "@sanity/icons/ChevronRight";
import { FormRow, defineDocumentFieldAction, definePlugin, getPublishedId, getVersionFromId, isDocumentSchemaType, isRecord, pathToString, useDocumentPreviewStore, useDocumentStore, usePerspective, useTranslation, useWorkspace } from "sanity";
import { MasterDetailIcon } from "@sanity/icons/MasterDetail";
import { PaneRouterContext as PaneRouterContext$1, usePaneRouter } from "sanity/structure";
/** @public */
const useSharedState = (key, value) => {
	let $ = c(5), context = useContext(PresentationSharedStateContext);
	if (!context) throw Error("Preview Snapshots context is missing");
	let { setValue } = context, t0, t1;
	$[0] !== key || $[1] !== setValue || $[2] !== value ? (t0 = () => {
		setValue(key, value);
	}, t1 = [
		key,
		value,
		setValue
	], $[0] = key, $[1] = setValue, $[2] = value, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1);
};
function usePresentationPerspectiveStack() {
	let $ = c(3), { perspectiveStack } = usePerspective(), paneRouter = useContext(PaneRouterContext$1);
	if (!paneRouter) throw Error("PaneRouter not found");
	let scheduledDraftPerspective = paneRouter.params?.scheduledDraft, t0;
	return $[0] !== perspectiveStack || $[1] !== scheduledDraftPerspective ? (t0 = scheduledDraftPerspective ? [scheduledDraftPerspective, ...perspectiveStack] : perspectiveStack, $[0] = perspectiveStack, $[1] = scheduledDraftPerspective, $[2] = t0) : t0 = $[2], t0;
}
const INITIAL_STATE = { locations: [] };
function useDocumentLocations(props) {
	let $ = c(29), { id, resolvers, type, version } = props, documentStore = useDocumentStore(), documentPreviewStore = useDocumentPreviewStore(), perspectiveStack = usePresentationPerspectiveStack(), variant = usePresentationVariant(), resolver = resolvers && (typeof resolvers == "function" ? resolvers : resolvers[type.name]), t0 = resolver ? "resolving" : "empty", t1;
	$[0] === t0 ? t1 = $[1] : (t1 = {
		state: INITIAL_STATE,
		status: t0
	}, $[0] = t0, $[1] = t1);
	let initialResult = t1, t2;
	bb0: {
		if (!resolver) {
			t2 = void 0;
			break bb0;
		}
		if (typeof resolver == "function") {
			let t3;
			if ($[2] !== documentStore || $[3] !== id || $[4] !== perspectiveStack || $[5] !== resolver || $[6] !== type.name || $[7] !== variant || $[8] !== version) {
				let _result = resolver({
					id,
					type: type.name,
					version,
					perspectiveStack,
					variant
				}, { documentStore });
				t3 = isObservable(_result) ? _result : of(_result), $[2] = documentStore, $[3] = id, $[4] = perspectiveStack, $[5] = resolver, $[6] = type.name, $[7] = variant, $[8] = version, $[9] = t3;
			} else t3 = $[9];
			t2 = t3;
			break bb0;
		}
		if ("select" in resolver && "resolve" in resolver) {
			let t3;
			if ($[10] !== documentPreviewStore || $[11] !== id || $[12] !== perspectiveStack || $[13] !== resolver || $[14] !== type || $[15] !== variant) {
				let doc = {
					_type: "reference",
					_ref: id
				}, _type = {
					...type,
					preview: { select: resolver.select }
				}, options = {
					perspective: perspectiveStack,
					variant
				}, t4;
				$[17] === resolver ? t4 = $[18] : (t4 = (preview) => resolver.resolve(preview.snapshot || null), $[17] = resolver, $[18] = t4), t3 = documentPreviewStore.observeForPreview(doc, _type, options).pipe(map(t4)), $[10] = documentPreviewStore, $[11] = id, $[12] = perspectiveStack, $[13] = resolver, $[14] = type, $[15] = variant, $[16] = t3;
			} else t3 = $[16];
			t2 = t3;
			break bb0;
		}
		let t3;
		$[19] === resolver ? t3 = $[20] : (t3 = of(resolver), $[19] = resolver, $[20] = t3), t2 = t3;
	}
	let result = t2, t3;
	bb1: {
		if (!result) {
			let t4;
			$[21] === initialResult ? t4 = $[22] : (t4 = of(initialResult), $[21] = initialResult, $[22] = t4), t3 = t4;
			break bb1;
		}
		let t4;
		if ($[23] !== initialResult || $[24] !== result) {
			let hasResolved = !1, resolved$ = result.pipe(map(_temp$3), tap(() => {
				hasResolved = !0;
			}));
			t4 = defer(() => hasResolved ? resolved$ : resolved$.pipe(startWith$1(initialResult))), $[23] = initialResult, $[24] = result, $[25] = t4;
		} else t4 = $[25];
		t3 = t4;
	}
	let { state: state_0, status } = useObservable(t3, initialResult), t4;
	return $[26] !== state_0 || $[27] !== status ? (t4 = {
		state: state_0,
		status
	}, $[26] = state_0, $[27] = status, $[28] = t4) : t4 = $[28], t4;
}
function _temp$3(state) {
	return {
		state: state || INITIAL_STATE,
		status: state ? "resolved" : "empty"
	};
}
function useCurrentPresentationToolName() {
	return usePresentationTool(!1)?.name ?? void 0;
}
const TONE_ICONS = {
	positive: InfoOutlineIcon,
	caution: WarningOutlineIcon,
	critical: ErrorOutlineIcon
};
function LocationsBanner(props) {
	let $ = c(40), { documentId, options, resolvers, schemaType, showPresentationTitle, version } = props, t0;
	$[0] !== documentId || $[1] !== resolvers || $[2] !== schemaType || $[3] !== version ? (t0 = {
		id: documentId,
		version,
		resolvers,
		type: schemaType
	}, $[0] = documentId, $[1] = resolvers, $[2] = schemaType, $[3] = version, $[4] = t0) : t0 = $[4];
	let { state, status } = useDocumentLocations(t0), isResolving = status === "resolving", { locations, message, tone } = state, locationsCount = locations?.length || 0, { t } = useTranslation(presentationLocaleNamespace), presentation = useContext(PresentationContext), presentationName = presentation?.name, [expanded, setExpanded] = useState(!1), t1;
	$[5] === locationsCount ? t1 = $[6] : (t1 = () => {
		locationsCount && setExpanded(_temp$2);
	}, $[5] = locationsCount, $[6] = t1);
	let toggle = t1, t2;
	$[7] !== isResolving || $[8] !== locationsCount || $[9] !== message || $[10] !== t ? (t2 = isResolving ? t("locations-banner.resolving.text") : message || t("locations-banner.locations-count", { count: locationsCount }), $[7] = isResolving, $[8] = locationsCount, $[9] = message, $[10] = t, $[11] = t2) : t2 = $[11];
	let title = t2, ToneIcon = tone ? TONE_ICONS[tone] : void 0;
	if (!resolvers || status === "empty") return null;
	let t3;
	$[12] === Symbol.for("react.memo_cache_sentinel") ? (t3 = { margin: -1 }, $[12] = t3) : t3 = $[12];
	let t4;
	$[13] !== ToneIcon || $[14] !== locations || $[15] !== options || $[16] !== showPresentationTitle || $[17] !== title || $[18] !== tone ? (t4 = !locations && /* @__PURE__ */ jsxs(Flex, {
		alignItems: "flex-start",
		gap: 3,
		padding: 3,
		children: [tone && ToneIcon && /* @__PURE__ */ jsx(Box, {
			flexBasis: "auto",
			flexGrow: 0,
			flexShrink: 0,
			children: /* @__PURE__ */ jsx(Icon, {
				size: 1,
				muted: !0,
				icon: ToneIcon,
				tone,
				style: { margin: "-0.375rem" }
			})
		}), /* @__PURE__ */ jsx(Box, {
			flexBasis: "0%",
			flexGrow: 1,
			children: /* @__PURE__ */ jsxs(Text, {
				size: 1,
				weight: "medium",
				as: "div",
				trim: !0,
				tone,
				children: [showPresentationTitle && /* @__PURE__ */ jsxs(Fragment$1, { children: [options.title || "Presentation", " · "] }), title]
			})
		})]
	}), $[13] = ToneIcon, $[14] = locations, $[15] = options, $[16] = showPresentationTitle, $[17] = title, $[18] = tone, $[19] = t4) : t4 = $[19];
	let t5;
	$[20] !== documentId || $[21] !== expanded || $[22] !== isResolving || $[23] !== locations || $[24] !== locationsCount || $[25] !== options || $[26] !== presentation || $[27] !== presentationName || $[28] !== schemaType || $[29] !== showPresentationTitle || $[30] !== title || $[31] !== toggle || $[32] !== tone ? (t5 = locations && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Card, {
		as: locationsCount ? "button" : void 0,
		onClick: toggle,
		padding: 3,
		radius: 1,
		tone: "inherit",
		children: /* @__PURE__ */ jsxs(Flex, {
			gap: 3,
			children: [/* @__PURE__ */ jsx(Box, {
				flexBasis: "auto",
				flexGrow: 0,
				flexShrink: 0,
				children: isResolving ? /* @__PURE__ */ jsx(Spinner, { size: 1 }) : locationsCount === 0 ? /* @__PURE__ */ jsx(Icon, {
					size: 1,
					icon: InfoOutlineIcon,
					tone,
					style: { margin: "-0.375rem" }
				}) : /* @__PURE__ */ jsx(Icon, {
					size: 1,
					icon: ChevronRightIcon,
					tone,
					style: {
						transform: `rotate(${expanded ? "90deg" : 0})`,
						transition: "transform 100ms ease-in-out",
						margin: "-0.375rem"
					}
				})
			}), /* @__PURE__ */ jsx(Box, {
				flexBasis: "0%",
				flexGrow: 1,
				children: /* @__PURE__ */ jsxs(Text, {
					size: 1,
					weight: "medium",
					as: "div",
					trim: !0,
					tone,
					children: [showPresentationTitle && /* @__PURE__ */ jsxs(Fragment$1, { children: [options.title || "Presentation", " · "] }), title]
				})
			})]
		})
	}), /* @__PURE__ */ jsx(Flex, {
		hidden: !expanded,
		marginTop: 1,
		gap: 1,
		flexDirection: "column",
		children: locations.map((l) => {
			let active = !1;
			return (options.name || "presentation") === presentationName && presentation?.params.preview && (active = areUrlsMatching(presentation.params.preview, l.href)), /* @__PURE__ */ jsx(LocationItem, {
				active,
				documentId,
				documentType: schemaType.name,
				node: l,
				toolName: options.name || "presentation",
				tone
			}, l.href);
		})
	})] }), $[20] = documentId, $[21] = expanded, $[22] = isResolving, $[23] = locations, $[24] = locationsCount, $[25] = options, $[26] = presentation, $[27] = presentationName, $[28] = schemaType, $[29] = showPresentationTitle, $[30] = title, $[31] = toggle, $[32] = tone, $[33] = t5) : t5 = $[33];
	let t6;
	$[34] !== t4 || $[35] !== t5 ? (t6 = /* @__PURE__ */ jsxs("div", {
		style: t3,
		children: [t4, t5]
	}), $[34] = t4, $[35] = t5, $[36] = t6) : t6 = $[36];
	let t7;
	return $[37] !== t6 || $[38] !== tone ? (t7 = /* @__PURE__ */ jsx(Card, {
		padding: 1,
		radius: 2,
		border: !0,
		tone,
		children: t6
	}), $[37] = t6, $[38] = tone, $[39] = t7) : t7 = $[39], t7;
}
function _temp$2(v) {
	return !v;
}
function LocationItem(props) {
	let $ = c(36), { documentId, documentType, node, active, toolName, tone } = props, presentation = useContext(PresentationContext), isCurrentTool = toolName === useCurrentPresentationToolName(), navigate = presentation?.navigate, { params: paneParams } = usePaneRouter(), t0 = presentation?.structureParams, t1;
	$[0] !== documentId || $[1] !== documentType || $[2] !== node.href || $[3] !== paneParams || $[4] !== t0 || $[5] !== toolName ? (t1 = {
		intent: "edit",
		params: {
			id: documentId,
			type: documentType,
			...t0,
			...paneParams,
			mode: "presentation",
			presentation: toolName,
			preview: node.href
		}
	}, $[0] = documentId, $[1] = documentType, $[2] = node.href, $[3] = paneParams, $[4] = t0, $[5] = toolName, $[6] = t1) : t1 = $[6];
	let presentationLinkProps = useIntentLink(t1), t2;
	$[7] !== navigate || $[8] !== node.href ? (t2 = () => {
		navigate?.({ params: { preview: node.href } });
	}, $[7] = navigate, $[8] = node.href, $[9] = t2) : t2 = $[9];
	let handleCurrentToolClick = t2, IconComponent = node.icon ?? DesktopIcon, t3;
	$[10] !== isCurrentTool || $[11] !== presentationLinkProps ? (t3 = isCurrentTool ? {} : presentationLinkProps, $[10] = isCurrentTool, $[11] = presentationLinkProps, $[12] = t3) : t3 = $[12];
	let t4 = isCurrentTool ? handleCurrentToolClick : presentationLinkProps.onClick, t5;
	$[13] === Symbol.for("react.memo_cache_sentinel") ? (t5 = { margin: "-0.375rem" }, $[13] = t5) : t5 = $[13];
	let t6;
	$[14] !== IconComponent || $[15] !== tone ? (t6 = /* @__PURE__ */ jsx(Box, {
		flexBasis: "auto",
		flexGrow: 0,
		flexShrink: 0,
		children: /* @__PURE__ */ jsx(Icon, {
			size: 1,
			icon: IconComponent,
			tone,
			style: t5
		})
	}), $[14] = IconComponent, $[15] = tone, $[16] = t6) : t6 = $[16];
	let t7;
	$[17] !== node.title || $[18] !== tone ? (t7 = /* @__PURE__ */ jsx(Text, {
		size: 1,
		weight: "medium",
		as: "div",
		trim: !0,
		tone,
		children: node.title
	}), $[17] = node.title, $[18] = tone, $[19] = t7) : t7 = $[19];
	let t8;
	$[20] !== node.href || $[21] !== node.showHref || $[22] !== tone ? (t8 = node.showHref !== !1 && /* @__PURE__ */ jsx(Text, {
		muted: !0,
		size: 1,
		truncate: 1,
		as: "div",
		trim: !0,
		tone,
		children: node.href
	}), $[20] = node.href, $[21] = node.showHref, $[22] = tone, $[23] = t8) : t8 = $[23];
	let t9;
	$[24] !== t7 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, {
		flexBasis: "0%",
		flexGrow: 1,
		gap: 2,
		flexDirection: "column",
		children: [t7, t8]
	}), $[24] = t7, $[25] = t8, $[26] = t9) : t9 = $[26];
	let t10;
	$[27] !== t6 || $[28] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, {
		gap: 3,
		children: [t6, t9]
	}), $[27] = t6, $[28] = t9, $[29] = t10) : t10 = $[29];
	let t11;
	return $[30] !== active || $[31] !== node.href || $[32] !== t10 || $[33] !== t3 || $[34] !== t4 ? (t11 = /* @__PURE__ */ jsx(Card, {
		...t3,
		as: "a",
		onClick: t4,
		padding: 3,
		radius: 1,
		pressed: active,
		tone: "inherit",
		children: t10
	}, node.href), $[30] = active, $[31] = node.href, $[32] = t10, $[33] = t3, $[34] = t4, $[35] = t11) : t11 = $[35], t11;
}
/**
* Compares two URLs to determine if they match based on origin, pathname, and search parameters
* The previewUrl should have all the search parameters that are in the locationUrl
*/
function areUrlsMatching(previewUrlString, locationUrlString) {
	try {
		let previewUrl = new URL(previewUrlString, location.origin), locationUrl = new URL(locationUrlString, previewUrl.origin);
		if (previewUrl.origin !== locationUrl.origin || previewUrl.pathname !== locationUrl.pathname) return !1;
		let locationParams = new URLSearchParams(locationUrl.search), previewParams = new URLSearchParams(previewUrl.search);
		for (let [key, value] of locationParams.entries()) if (previewParams.get(key) !== value) return !1;
		return !0;
	} catch {
		return !1;
	}
}
const LocationStack = /* @__PURE__ */ styled.div.withConfig({
	displayName: "LocationStack",
	componentId: "sc-m4xsxl-0"
})((props) => {
	let theme = getTheme_v2(props.theme);
	return css`display:flex;flex-direction:column;gap:${rem(theme.space[2])};min-height:${rem(42)};margin-bottom:${rem(theme.space[5])};&:empty{display:none;}`;
});
function PresentationDocumentHeader(props) {
	let $ = c(19), { documentId, options, schemaType, version } = props, context = useContext(PresentationDocumentContext), t0;
	$[0] === context?.options ? t0 = $[1] : (t0 = context?.options || [], $[0] = context?.options, $[1] = t0);
	let contextOptions = t0, resolvers, t1;
	$[2] === contextOptions ? (resolvers = $[3], t1 = $[4]) : (resolvers = contextOptions.map(_temp$1), t1 = resolvers.some(Boolean), $[2] = contextOptions, $[3] = resolvers, $[4] = t1);
	let hasResolvers = t1;
	if (context && context.options[0] !== options || !hasResolvers) return null;
	let t2;
	if ($[5] !== contextOptions || $[6] !== documentId || $[7] !== resolvers || $[8] !== schemaType || $[9] !== version) {
		let t3;
		$[11] !== contextOptions.length || $[12] !== documentId || $[13] !== resolvers || $[14] !== schemaType || $[15] !== version ? (t3 = (_options, idx) => /* @__PURE__ */ jsx(LocationsBanner, {
			documentId,
			options: _options,
			resolvers: resolvers[idx],
			schemaType,
			showPresentationTitle: contextOptions.length > 1,
			version
		}, idx), $[11] = contextOptions.length, $[12] = documentId, $[13] = resolvers, $[14] = schemaType, $[15] = version, $[16] = t3) : t3 = $[16], t2 = contextOptions.map(t3), $[5] = contextOptions, $[6] = documentId, $[7] = resolvers, $[8] = schemaType, $[9] = version, $[10] = t2;
	} else t2 = $[10];
	let t3;
	return $[17] === t2 ? t3 = $[18] : (t3 = /* @__PURE__ */ jsx(FormRow, { children: /* @__PURE__ */ jsx(LocationStack, { children: t2 }) }), $[17] = t2, $[18] = t3), t3;
}
function _temp$1(o) {
	return o.resolve?.locations || o.locate;
}
/** @internal */
function PresentationDocumentProvider(props) {
	let $ = c(21), { children, options } = props, parent = useContext(PresentationDocumentContext), parentRegister = parent?.register, [nestedOptions, setNestedOptions] = useState(_temp), t0;
	$[0] === parentRegister ? t0 = $[1] : (t0 = (options_0) => parentRegister ? parentRegister(options_0) : (setNestedOptions((prev) => [options_0].concat(prev)), () => {
		setNestedOptions((prev_0) => prev_0.filter((o) => o !== options_0));
	}), $[0] = parentRegister, $[1] = t0);
	let register = t0, t1;
	$[2] !== nestedOptions || $[3] !== options || $[4] !== parent?.options ? (t1 = parent?.options || [options, ...nestedOptions], $[2] = nestedOptions, $[3] = options, $[4] = parent?.options, $[5] = t1) : t1 = $[5];
	let t2;
	$[6] !== register || $[7] !== t1 ? (t2 = {
		options: t1,
		register
	}, $[6] = register, $[7] = t1, $[8] = t2) : t2 = $[8];
	let context = t2, t3;
	$[9] === register ? t3 = $[10] : (t3 = (options_1) => register(options_1), $[9] = register, $[10] = t3);
	let registerEffectEvent = useEffectEvent$1(t3), t4;
	$[11] !== options || $[12] !== parentRegister || $[13] !== registerEffectEvent ? (t4 = () => parentRegister ? registerEffectEvent(options) : void 0, $[11] = options, $[12] = parentRegister, $[13] = registerEffectEvent, $[14] = t4) : t4 = $[14];
	let t5;
	$[15] !== options || $[16] !== parentRegister ? (t5 = [options, parentRegister], $[15] = options, $[16] = parentRegister, $[17] = t5) : t5 = $[17], useLayoutEffect(t4, t5);
	let t6;
	return $[18] !== children || $[19] !== context ? (t6 = /* @__PURE__ */ jsx(PresentationDocumentContext.Provider, {
		value: context,
		children
	}), $[18] = children, $[19] = context, $[20] = t6) : t6 = $[20], t6;
}
function _temp() {
	return [];
}
function useOpenInStructureAction(props) {
	let $ = c(13), { documentId, documentType, path } = props, workspace = useWorkspace(), { navigateIntent } = useRouter(), presentation = useContext(PresentationContext), t0 = presentation?.name || "presentation", t1;
	$[0] !== documentId || $[1] !== documentType || $[2] !== t0 || $[3] !== workspace.tools ? (t1 = findStructureTool(workspace.tools, documentId, documentType, t0), $[0] = documentId, $[1] = documentType, $[2] = t0, $[3] = workspace.tools, $[4] = t1) : t1 = $[4];
	let defaultStructureTool = t1, t2 = !presentation || path.length > 0 || !defaultStructureTool, t3 = defaultStructureTool?.icon || MasterDetailIcon, t4 = `Open in ${defaultStructureTool?.title || "Structure"}`, t5;
	return $[5] !== documentId || $[6] !== documentType || $[7] !== navigateIntent || $[8] !== path || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 ? (t5 = {
		type: "action",
		hidden: t2,
		icon: t3,
		title: t4,
		onAction() {
			navigateIntent("edit", {
				id: documentId,
				type: documentType,
				mode: "structure",
				path: pathToString(path)
			});
		},
		renderAsButton: !0
	}, $[5] = documentId, $[6] = documentType, $[7] = navigateIntent, $[8] = path, $[9] = t2, $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
const openInStructure = defineDocumentFieldAction({
	name: "presentation/openInStructure",
	useAction: useOpenInStructureAction
});
function findStructureTool(tools, documentId, documentType, presentationToolName) {
	let results = tools.filter((t) => t.name !== presentationToolName).map((t) => ({
		tool: t,
		match: t.canHandleIntent?.("edit", {
			id: documentId,
			type: documentType,
			mode: "structure"
		}, {})
	})), modeMatches = results.filter((t) => isRecord(t.match) && t.match.mode);
	return modeMatches.length > 0 ? modeMatches[0].tool : results.filter((t) => t.match)[0]?.tool;
}
const preservedSearchParamKeys = ["preview", "viewport"];
/**
* @internal
*/
function getIntentState(intent, params, routerState, payload) {
	let { id, mode, path, presentation, type, ...searchParams } = params, _searchParams = {
		...(routerState?._searchParams || []).filter(([key]) => preservedSearchParamKeys.includes(key)).reduce((acc, [key, value]) => ({
			...acc,
			[key]: value
		}), {}),
		...searchParams
	};
	return intent === "edit" && id ? (_searchParams.preview = _searchParams.preview || new URLSearchParams(window.location.search).get("preview") || "/", {
		type: type || "*",
		id: getPublishedId(id),
		path,
		_searchParams: Object.entries(_searchParams)
	}) : intent === "create" ? (_searchParams.preview = _searchParams.preview || new URLSearchParams(window.location.search).get("preview") || "/", payload && typeof payload == "object" && (_searchParams.templateParams = encodeJsonParams(payload)), {
		type: type || "*",
		id: id || uuid(),
		_searchParams: Object.entries(_searchParams)
	}) : {
		intent,
		params,
		payload
	};
}
const router = route.create("/", { __unsafe_disableScopedSearchParams: !0 }, [route.intents("/intent"), route.create(":type", [route.create(":id", [route.create(":path")])])]), PresentationTool = lazy(() => import("./PresentationToolGrantsCheck-BkCkXbqE.js")), BroadcastDisplayedDocument = lazy(() => import("./BroadcastDisplayedDocument-Ngf-KZ38.js"));
/**
* Define locations for a given document type.
* This function doesn't do anything itself, it is used to provide type information.
* @param resolver - resolver that return locations for a document.
* @public
*/
function defineLocations(resolver) {
	return resolver;
}
/**
* Define documents for a given location.
* This function doesn't do anything itself, it is used to provide type information.
* @param resolvers - resolvers that return documents.
* @public
*/
function defineDocuments(resolvers) {
	return resolvers;
}
/** @public */
const presentationTool = definePlugin((options) => {
	let toolName = options.name || "presentation";
	"locate" in options && console.warn("Presentation’s `locate` option is deprecated. Use `resolve.locations` instead.");
	let hasLocationsResolver = !!(options.resolve?.locations || options.locate);
	function PresentationDocumentInput(props) {
		let $ = c(19), value = props.value, t0;
		$[0] === value?._id ? t0 = $[1] : (t0 = value?._id ? getPublishedId(value?._id) : void 0, $[0] = value?._id, $[1] = t0);
		let documentId = t0, t1;
		$[2] === value ? t1 = $[3] : (t1 = value?._id ? getVersionFromId(value._id) : void 0, $[2] = value, $[3] = t1);
		let documentVersion = t1;
		if (isDocumentSchemaType(props.schemaType)) {
			let t2;
			$[4] !== documentId || $[5] !== documentVersion || $[6] !== props.schemaType ? (t2 = hasLocationsResolver && documentId && /* @__PURE__ */ jsx(PresentationDocumentHeader, {
				documentId,
				version: documentVersion,
				options,
				schemaType: props.schemaType
			}), $[4] = documentId, $[5] = documentVersion, $[6] = props.schemaType, $[7] = t2) : t2 = $[7];
			let t3;
			$[8] === props ? t3 = $[9] : (t3 = props.renderDefault(props), $[8] = props, $[9] = t3);
			let t4;
			$[10] !== documentId || $[11] !== value ? (t4 = /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(BroadcastDisplayedDocument, { value }, documentId) }, "broadcast-displayed-document"), $[10] = documentId, $[11] = value, $[12] = t4) : t4 = $[12];
			let t5;
			return $[13] !== t2 || $[14] !== t3 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsxs(PresentationDocumentProvider, {
				options,
				children: [
					t2,
					t3,
					t4
				]
			}), $[13] = t2, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
		}
		let t2;
		return $[17] === props ? t2 = $[18] : (t2 = props.renderDefault(props), $[17] = props, $[18] = t2), t2;
	}
	function canHandleCreateIntent(params) {
		return !("type" in params) || "presentation" in params && params.presentation !== toolName ? !1 : "template" in params ? { template: !0 } : !0;
	}
	function canHandleEditIntent(params) {
		return !("type" in params) || !("id" in params) || "presentation" in params && params.presentation !== toolName ? !1 : "mode" in params ? { mode: params.mode === EDIT_INTENT_MODE } : !0;
	}
	return {
		i18n: { bundles: [presentationUsEnglishLocaleBundle] },
		document: { unstable_fieldActions: (prev) => [...prev.filter((a) => a.name !== openInStructure.name), openInStructure] },
		form: { components: { input: PresentationDocumentInput } },
		tools: [{
			icon: options.icon || DEFAULT_TOOL_ICON,
			name: toolName,
			title: options.title || "Presentation",
			component: PresentationTool,
			options,
			canHandleIntent(intent, params) {
				return intent === "create" ? canHandleCreateIntent(params) : intent === "edit" && canHandleEditIntent(params);
			},
			getIntentState,
			router,
			__internalApplicationType: "sanity/presentation"
		}]
	};
});
export { defineDocuments, defineLocations, presentationTool, usePresentationNavigate, usePresentationParams, useSharedState };

//# sourceMappingURL=presentation.js.map